import api from '../api';
export function changed() { window.dispatchEvent(new Event('esf-notifications-changed')); }
export function pushChanged() { window.dispatchEvent(new Event('esf-push-changed')); }
export function pushSupport() {
  const ua=navigator.userAgent||'';
  const ios=/iPhone|iPad|iPod/i.test(ua)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  const installed=!!(navigator.standalone||window.matchMedia?.('(display-mode: standalone)').matches);
  return {ios,installed,supported:!!(window.isSecureContext&&window.Notification&&window.PushManager&&navigator.serviceWorker&&(!ios||installed)),permission:window.Notification?.permission||'unsupported'};
}
export async function devicePushStatus() {
  const info=pushSupport();
  if(!info.supported)return {...info,enabled:false,reason:info.ios&&!info.installed?'install':'unsupported'};
  if(info.permission!=='granted')return {...info,enabled:false,reason:info.permission};
  const registration=await navigator.serviceWorker.getRegistration(),subscription=await registration?.pushManager?.getSubscription();
  const {data:settings}=await api.get('/api/notifications/settings',{timeout:10000});
  if(!settings.publicKey)return {...info,settings,enabled:false,reason:'server'};
  if(!subscription)return {...info,settings,enabled:false,reason:'subscription'};
  const {data}=await api.post('/api/notifications/device-status',{endpoint:subscription.endpoint},{timeout:10000});
  return {...info,settings,subscription,enabled:settings.push_enabled&&data.registered,reason:!settings.push_enabled?'account':!data.registered?'subscription':'enabled'};
}
export async function activateDevicePush() {
  // Request permission inside the click gesture, before any network awaits (especially iOS).
  const info=pushSupport();
  if(!info.supported)throw Error('راهنمای گوشی یا مرورگر خود را دنبال کنید.');
  if(info.permission==='denied')throw Error('اجازه اعلان مسدود است؛ ابتدا از تنظیمات مرورگر اجازه دهید.');
  const permission=await Notification.requestPermission();
  if(permission!=='granted')throw Error('اجازه اعلان داده نشد؛ راهنما را بررسی کنید.');
  const {data:settings}=await api.get('/api/notifications/settings');
  await enableDevicePush(settings.publicKey);
  await api.put('/api/notifications/settings',{push_enabled:true,hide_details:settings.hide_details,categories:settings.categories});
  pushChanged();
}
export async function disableDevicePush() {
  const registration = await navigator.serviceWorker?.getRegistration();
  const subscription = await registration?.pushManager?.getSubscription();
  if (!subscription) return;
  const endpoint = subscription.endpoint;
  await subscription.unsubscribe();
  await api.delete('/api/notifications/subscriptions', { data: { endpoint } }).catch(() => {});
}
export async function enableDevicePush(publicKey) {
  if (!publicKey) throw Error('ارسال پوش هنوز روی سرور تنظیم نشده است.');
  if (!window.isSecureContext || !('Notification' in window) || !('PushManager' in window) || !navigator.serviceWorker) throw Error('این مرورگر از پوش پشتیبانی نمی‌کند؛ در آیفون سایت را نصب کنید و از داخل برنامه باز کنید.');
  const permission = Notification.permission === 'granted' ? 'granted' : await Notification.requestPermission();
  if (permission !== 'granted') throw Error('اجازه اعلان داده نشد؛ تنظیمات اعلان مرورگر را بررسی کنید.');
  const registration = await navigator.serviceWorker.getRegistration();
  if (!registration?.active) throw Error('نسخه قابل نصب هنوز آماده نیست؛ صفحه را از نسخه بیلدشده باز کنید.');
  const padding = '='.repeat((4 - publicKey.length % 4) % 4);
  const bytes = Uint8Array.from(atob((publicKey + padding).replace(/-/g, '+').replace(/_/g, '/')), character => character.charCodeAt(0));
  const subscription = await registration.pushManager.getSubscription() || await registration.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes });
  await api.post('/api/notifications/subscriptions', subscription.toJSON());
}
